<template>
  <div>
    <div class="listNav">
      <div class="main">
        <span>您的位置：</span>
        <span>首页</span>
        <span>></span>
        <span>资源库</span>
        <span>></span>
        <span>资源库详情</span>
        <span>></span>
        <span>课程列表</span>
        <span>></span>
        <span>课程详情</span>
      </div>
    </div>
    <div class="mainBg">
      <div class="main">
        <div class="maincontent couMaincontent">
          <div class="couTitle">新突破大学的英语课程</div>
          <div class="courseTea">杨雪教授</div>
          <div>
            <el-row :gutter="0">
              <el-col :span="17">
                <div class="grid-content bg-purple">
                  <div class="player">
                    <video-player
                      class="video-player vjs-custom-skin"
                      ref="videoPlayer"
                      :playsinline="true"
                      style="object-fit:fill"
                      :options="playerOptions"
                      :x5-video-player-fullscreen="true"
                      @pause="onPlayerPause($event)"
                      @play="onPlayerPlay($event)"
                      @fullscreenchange="onFullscreenChange($event)"
                      @click="fullScreen"
                    ></video-player>
                  </div>
                </div>
              </el-col>
              <el-col :span="7">
                <div class="grid-content bg-purple">
                  <div class="playerTit">
                    <div class="playerTitIitem">
                      <div class="itemTit">课程名称</div>
                      <!-- <div
                      class="itemTextBox"
                      v-for="(sedItem,index) in item.smallChapter"
                      :key="index"
                    >
                      <div
                        class="itemText"
                        @click="outlieItem(sedItem.filePath)"
                      >{{sedItem.realName}}</div>
                      </div>-->
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pictureImg: '',
      playerOptions: {
        //playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: 'video/mp4',
            src:
              'http://wutonghua-oss.oss-cn-qingdao.aliyuncs.com/jiaofa/onlinechapter/03墙下带形基础.mp4'
          }
        ],
        poster: '',
        width: '600px',
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          // timeDivider: true,
          // durationDisplay: true,
          // remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      outlineList: [],
      onlTitle: '',
      onlSchname: '',
      onlTeaname: ''
    }
  },
  methods: {
    async getOnlineDetailsOutline() {
      // let fid = window.sessionStorage.getItem('onlinefid')
      // console.log(fid)
      let fid = this.$route.query.fid
      const { data: res } = await this.$http.post('/online/selectDaGang.do ', {
        fid: fid
      })
      // console.log(res)
      this.playerOptions.sources[0].src = res.data[0].smallChapter[0].filePath
      // console.log(res.data[0].smallChapter[0].filePath)
      this.outlineList = res.data
    },
    outlieItem(filePath) {
      // console.log(filePath)
      this.playerOptions.sources[0].src = filePath
    },
    // 视频方法
    fullScreen() {
      const player = this.$refs.videoPlayer.player
      player.requestFullscreen() //调用全屏api方法
      player.isFullscreen(true)
      player.play()
    },
    onPlayerPlay(player) {
      player.play()
    },
    onPlayerPause(player) {
      // alert("pause");
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    }
  }
}
</script>
<style lang="scss" scoped>
.mainBg {
  width: 100%;
  background-image: url('../../assets/img/navbarbg.png');
}
.couMaincontent {
  height: 800px !important;
  margin: 0 30px;
}
.couTitle {
  font-size: 20px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  padding: 20px 0 15px;
}
.courseTea {
  font-size: 14px;
  color: rgba(153, 153, 153, 1);
  margin-bottom: 15px;
  span {
    margin-right: 30px;
  }
}
.player {
  margin: 30px 0 30px;
  background: rgba(0, 0, 0, 1);
}
.playerTit {
  padding: 0 20px;
  margin: 30px 0 30px;
  background: rgba(0, 0, 0, 1);
  height: 559px;
  .playerTitIitem {
    .itemTit {
      padding-top: 20px;
      color: rgba(199, 199, 199, 1);
    }
    .itemTextBox {
      padding-left: 20px;
      border-bottom: 1px solid rgba(102, 102, 102, 0.5);
      padding-bottom: 12px;
      .itemText {
        margin-top: 12px;
        color: rgba(102, 102, 102, 1);
      }
    }
  }
}
// ----------
.listNav {
  width: 100%;
  height: 42px;
  background: rgba(237, 234, 231, 1);
  span {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    line-height: 42px;
    margin-right: 5px;
  }
  :nth-child(10) {
    color: #b50e05;
  }
}
</style>